import { TrackReferenceOrPlaceholder } from "solid-livekit-components";

import { Track } from "livekit-client";
import { Channel } from "stoat.js";

import { shouldUseCenteredAvatarRow } from "./callLayoutMath";

/**
 * Whether any participant has active camera or screenshare video.
 */
export function hasActiveVideoTracks(
  tracks: TrackReferenceOrPlaceholder[],
): boolean {
  return tracks.some((trackRef) => {
    if (trackRef.source === Track.Source.ScreenShare) {
      return !!trackRef.publication && !trackRef.publication.isMuted;
    }

    if (trackRef.source === Track.Source.Camera) {
      return (
        !!trackRef.publication?.track && !trackRef.publication.isMuted
      );
    }

    return false;
  });
}

/**
 * Use centered avatar layout instead of the participant tile grid.
 * Kept for callers that only know mic count; prefer shouldUseAvatarCallLayout
 * when ringing invitees are also known.
 */
export function shouldUseDualCallLayout(options: {
  channel: Channel | undefined;
  micCount: number;
  hasFocus: boolean;
  vidTracks: TrackReferenceOrPlaceholder[];
  ringingCount?: number;
}): boolean {
  return shouldUseCenteredAvatarRow({
    channelType: options.channel?.type,
    participantCount: options.micCount + (options.ringingCount ?? 0),
    hasFocus: options.hasFocus,
    hasActiveVideo: hasActiveVideoTracks(options.vidTracks),
  });
}
